<div
  class="sa-modal__backdrop"
  [class.sa-modal__backdrop--visible]="isOpen()"
  aria-hidden="true"
  (click)="onBackdropClick($event)"
></div>

@if (product(); as p) {
  <section
    #modalEl
    class="sa-modal"
    [class.sa-modal--open]="isOpen()"
    role="dialog"
    aria-modal="true"
    aria-labelledby="sa-modal-title"
    tabindex="-1"
  >
    <header class="sa-modal__header">
      <div class="sa-modal__header-info">
        <app-icon [icon]="bellIcon" [size]="20" color="var(--color-brand-secondary)" />
        <h2 id="sa-modal-title" class="sa-modal__title">Avisarme cuando haya stock</h2>
      </div>
      <button
        #closeBtn
        class="sa-modal__close"
        type="button"
        aria-label="Cerrar"
        (click)="onClose()"
      >
        <app-icon [icon]="closeIcon" [size]="20" color="currentColor" />
      </button>
    </header>

    <div class="sa-modal__body">
      <article class="sa-modal__product">
        <img
          class="sa-modal__product-img"
          [src]="thumbnailUrl()"
          [alt]="p.name"
          loading="lazy"
          (error)="onImageError($event)"
        />
        <div class="sa-modal__product-info">
          <p class="sa-modal__product-name">{{ p.name }}</p>
          @if (subscriberCount() > 0) {
            <p class="sa-modal__product-meta">
              {{ subscriberCount() }}
              {{ subscriberCount() === 1 ? 'persona espera' : 'personas esperan' }}
              este producto.
            </p>
          }
        </div>
      </article>

      @if (subscribed()) {
        <p class="sa-modal__success" aria-live="polite">
          ✓ Te avisaremos cuando esté disponible.
        </p>
      } @else if (status() === 'already_subscribed') {
        <p class="sa-modal__success" aria-live="polite">
          ✓ Ya tienes una alerta activa para este producto con ese correo.
        </p>
      } @else {
        <form class="sa-modal__form" (submit)="onSubmit($event)">
          <label class="sa-modal__label" for="sa-email">
            Te enviaremos un correo apenas vuelva a estar disponible.
          </label>
          <div #inputWrap class="sa-modal__input-wrap">
            <app-input
              id="sa-email"
              type="email"
              placeholder="tu@email.com"
              [value]="email()"
              [disabled]="pending()"
              (valueChange)="email.set($event)"
            />
          </div>
          @if (status() === 'error') {
            <p class="sa-modal__error" aria-live="polite">
              No pudimos registrar tu alerta. Revisa el correo e intenta de nuevo.
            </p>
          } @else if (status() === 'prepurchase') {
            <p class="sa-modal__error" aria-live="polite">
              Este producto está en pre-venta. Búscalo en la sección de precompras.
            </p>
          }
          <div class="sa-modal__actions">
            <app-button
              variant="ghost"
              size="md"
              type="button"
              (click)="onClose()"
            >
              Cancelar
            </app-button>
            <app-button
              variant="primary"
              size="md"
              type="submit"
              [disabled]="!canSubmit()"
              [loading]="pending()"
            >
              Avisarme
            </app-button>
          </div>
        </form>
      }
    </div>
  </section>
}
